module.exports = __webpack_public_path__ + "static/media/carrot.f7bf4657.svg";